import 'arrive';
import Swiper from 'swiper/bundle';

// Initialize Highlights slider when requested via data attribute

document.arrive('.block-highlights[data-carousel="true"]', { existing: true }, function (el) {
  const container = el.querySelector('.block-highlights__carousel.swiper');
  if (!container || container.dataset.swiperInitialized === 'true') return;

  container.dataset.swiperInitialized = 'true';

  const hasPagination = container.dataset.pagination === 'true';
  const paginationEl = hasPagination ? container.querySelector('.swiper-pagination') : null;

    // Support both custom and default classes for navigation buttons
  const nextEl = container.querySelector('.swiper-button-next, .button-next');
  const prevEl = container.querySelector('.swiper-button-prev, .button-prev');

  const swiper = new Swiper(container, {
    slidesPerView: 1.2,
    spaceBetween: 16,
    centeredSlides: false,
    loop: true,
    speed: 500,
    navigation: {
      nextEl: nextEl || undefined,
      prevEl: prevEl || undefined,
    },
    allowTouchMove: true,
    pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
    breakpoints: {
      550: { slidesPerView: 1.5, spaceBetween: 15 },
      768: { slidesPerView: 2.5, spaceBetween: 18 },
      1080: { slidesPerView: 3.5, spaceBetween: 20 },
      1561: { slidesPerView: 4.5, spaceBetween: 24 },
    },
  });
});
